import { useRemoveLastCharacter } from "../hooks/useRemoveLastCharacter";
import { Button } from "../components/Button";
import { StarsCanvas } from "../components/StarBackground";
import { useState } from "react";

export const Hero = ({ contactRef }: any) => {
  const titles = [
    "Software Engineer",
    "Game Developer",
    "Fullstack Developer",
    "Graphics Progammer",
  ];

  const { modifiedName } = useRemoveLastCharacter({ names: titles });

  return (
    <>
      <div className="w-full h-screen flex flex-col bg-black">
        <div className="absolute z-40 w-full">
          <div className="flex w-full h-screen justify-center items-center text-center">
            <div className="px-2 flex flex-col items-center">
              <h1 className="text-4xl font-bold md:text-5xl">
                Welcome to my Portfolio
              </h1>
              <p className="text-gray-300 text-xl lg:text-3xl">
                My name is Reece Carey
              </p>

              <p className="text-gray-300 text-xl pb-4 lg:text-xl">
                {modifiedName}|
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mt-6 w-full justify-center max-w-xs sm:max-w-md mx-auto relative z-50">
                <Button
                  text={"Contact me"}
                  onClick={() => {
                    contactRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                />
                <a href={"./assets/reece-carey-cv.pdf"} target="_blank" className="w-full sm:w-auto inline-block">
                  <Button
                    text={"Curriculum Vitae"}
                    primary={false}
                    onClick={() => {}}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <StarsCanvas />
      </div>
    </>
  );
};

export default Hero;
